<template>
  <LMap :center="[47, 2]" :zoom="6" style="height: 80vh">
    <LTileLayer :url="url" />
     <v-marker-cluster>
    <LMarker
      @click="$router.push(`/stations/${station.id_station}`)"
      v-for="(station, i) in user.stations"
      :key="i"
      :lat-lng="[station.latitude, station.longitude]"
    >
      <LIcon iconSize="150">
        <v-chip color="white" v-if="!station.last_data.error">
          <v-icon v-if="!station.last_data[0].rain">mdi-weather-sunny</v-icon> 
          <v-icon v-else>mdi-weather-pourring</v-icon> 

          {{station.last_data[0].temp}}°C</v-chip>
        <v-chip color="error" v-else><v-icon>mdi-close</v-icon> No data</v-chip>
        <!-- <v-btn x-small fab :color="station.last_data.error ? 'error' : 'white'"
          ><v-icon x-small color="primary">mdi-wifi</v-icon></v-btn
        > -->
      </LIcon>
    </LMarker>
     </v-marker-cluster>
      <LControl position="bottomright">
        <v-btn rounded to="/stations/create"> <v-icon>mdi-
        plus</v-icon> Ajouter une station </v-btn>
      </LControl>
  </LMap>
</template>

<script>
import { mapState } from "vuex";
import { LMap, LTileLayer, LMarker, LIcon, LControl } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

export default {
  computed: {
    ...mapState(["user"]),
  },
  components: {
    LMap,
    LTileLayer,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    LMarker,
    LIcon,
    LControl,
  },
  data: () => ({
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  }),
};
</script>

<style>
</style>